var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-logo"},[_c('h2',[(_vm.isBadged)?_c('div',[_c('span',{staticClass:"sponge-platform"},[_vm._v("Sponge ")]),_c('span',{staticClass:"subplatform",class:_vm.platform.id},[_vm._v(_vm._s(_vm.platform.suffix))])]):_c('div',[_vm._v(_vm._s(_vm.platform.name || _vm.platform.id))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }